import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { Search, ShieldAlert } from "lucide-react";
import { useAuth } from "../lib/auth";
import { callAdmin } from "../components/admin/shared";
import { PlayerCard } from "../components/admin/PlayerCard";
import { GiftPanel, CheatPanel } from "../components/admin/AdminTools";
import { ModLog } from "../components/admin/ModLog";
import { BackupPanel } from "../components/admin/BackupPanel";
import { RestorePanel } from "../components/admin/RestorePanel";
import { WipePanel } from "../components/admin/WipePanel";

// Admin & moderation panel. The menu entry is only shown to staff, but every action is checked by the server.
export default function AdminPage() {
  const { user } = useAuth();
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [selected, setSelected] = useState(null);
  const perms = user?.permissions || [];

  if (!user?.role) return <Navigate to="/roster" replace />;

  const search = async (e) => {
    e?.preventDefault();
    const r = await callAdmin("get", `/players?q=${encodeURIComponent(q)}`);
    if (r) setResults(r);
  };
  const changed = async (removed) => {
    if (removed) setSelected(null);
    await search();
    window.dispatchEvent(new CustomEvent("admin-log-refresh"));
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-8 space-y-5" data-testid="admin-page">
      <h1 className="font-heading text-3xl sm:text-4xl neon-pink flex items-center gap-3">
        <ShieldAlert size={32} /> {user.role === "admin" ? "Admin Panel" : "Moderation Panel"}
      </h1>

      {perms.includes("gifts.send") && <GiftPanel selected={selected} />}
      {perms.includes("cheats.use") && <CheatPanel />}
      {perms.includes("backup.manage") && <BackupPanel />}
      {perms.includes("backup.manage") && <RestorePanel />}
      {perms.includes("backup.manage") && <WipePanel />}

      <form onSubmit={search} className="flex gap-2" data-testid="admin-search-form">
        <input data-testid="admin-search-input" value={q} onChange={(e) => setQ(e.target.value)}
          placeholder={perms.includes("players.view_email") ? "Search players by name, e-mail or ID" : "Search players by name"}
          className="flex-1 px-3 py-2 rounded-xl bg-[#0A051A] border-2 border-[#FF007F]/40 focus:border-[#00F0FF] outline-none font-mono text-sm" />
        <button data-testid="admin-search-btn" type="submit" className="btn-neon text-xs flex items-center gap-2"><Search size={14} /> Search</button>
      </form>

      <div className="space-y-3" data-testid="admin-results">
        {results.map(p => (
          <div key={p.user_id} onClick={() => setSelected(p)} className={selected?.user_id === p.user_id ? "ring-2 ring-[#00F0FF] rounded-xl" : ""}>
            <PlayerCard p={p} perms={perms} onChanged={changed} />
          </div>
        ))}
      </div>

      <ModLog />
    </div>
  );
}
